export const SAVE_USER_DETAILS = "SAVE_USER_DETAILS"

export const saveUserDetails = (expirationDate, expirationMileage) => async (dispatch) => {
  dispatch({
    type: SAVE_USER_DETAILS,
    payload: { expirationDate, expirationMileage }
  })
}
